module.exports = __webpack_public_path__ + "static/img/packaging_tube.ab1ffff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/articles/packaging_tube.jpg
// module id = Z7NE
// module chunks = 1